import urlConfig from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { getReportHeaders } from "@adapters/infrastructures/urlConfig/Reports/reportHeaders";
import { LedgerSnapShotMapper } from "@domains/mapper/Reports/LedgerReport/LedgerReport";
import { LedgerDetailsMapper } from "@domains/mapper/Reports/LedgerReport/LedgerReportDetails";
import { snapShotExtentionMapper } from "@domains/mapper/Reports/LedgerReport/snapShotExtention";
import { contractNoteMapper } from "@domains/mapper/Reports/LedgerReport/LedgerContractNote";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { getIsInIFrame } from "@domains/utils/tokenParser";
class LedgerReportRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getLedgerSnapShot(req) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = req.ACCTYPE === "EQ"
            ? new URL(urlConfig.ledger + "snapshot")
            : new URL(urlConfig.ledgerComm + "snapshot");
        url.searchParams.append("accountId", req.accountId);
        url.searchParams.append("fromDate", req.fromDate);
        url.searchParams.append("toDate", req.toDate);
        url.searchParams.append("isPdf", String(req.isPdf));
        url.searchParams.append("duration", req.duration);
        if (req.ACCTYPE === "EQ")
            url.searchParams.append("isMtf", String(req.isMtf));
        if (req.ACCTYPE === "CO")
            url.searchParams.append("entity", String(req.entity));
        const ledgerSnaps = 
        // JSON.parse(dummyLedgerSnapShot);
        await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        return LedgerSnapShotMapper(ledgerSnaps.data);
    }
    async getLedgerDetail(req) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = req.accType === ILoginAccountTypes.EQ
            ? new URL(urlConfig.ledger + "detail")
            : new URL(urlConfig.ledgerComm + "detail");
        url.searchParams.append("accountId", req.accountId);
        url.searchParams.append("fromDate", req.fromDate);
        url.searchParams.append("toDate", req.toDate);
        url.searchParams.append("segment", String(req.segment));
        if (req.accType === ILoginAccountTypes.EQ)
            url.searchParams.append("isMtf", String(req.isMtf));
        if (req.accType === ILoginAccountTypes.CO)
            url.searchParams.append("entity", String(req.entity));
        url.searchParams.append("currentValue", String(req.currentValue));
        const ledgerDetails = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        // const ledgerDetails = JSON.parse(dummyLedgerDetails);
        return LedgerDetailsMapper(ledgerDetails.data, req.accType);
    }
    async snapShotEntentionDetails(req) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(urlConfig.ledger + "popup");
        url.searchParams.append("accountId", req.accountId);
        url.searchParams.append("fromDate", req.fromDate);
        url.searchParams.append("toDate", req.toDate);
        url.searchParams.append("segment", String(req.segment));
        url.searchParams.append("currentValue", String(req.currentValue));
        url.searchParams.append("flag", req.flag);
        const snapEntention = 
        // JSON.parse(dummySnapShotsExtention);
        await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        return snapShotExtentionMapper(snapEntention.data);
    }
    async contractNote(req) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(urlConfig.ledger + "contract/note");
        url.searchParams.append("accountId", req.accountId);
        url.searchParams.append("fromDate", req.fromDate);
        url.searchParams.append("exchange", req.exchange);
        url.searchParams.append("amount", String(req.amount));
        const snapEntention = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        return contractNoteMapper(snapEntention.data);
    }
    async contractPDF(req) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(urlConfig.ledger + "contract/pdf");
        const contractpdf = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            body: req,
            avoidAuthToken: getIsInIFrame(),
        });
        return contractpdf;
    }
}
export default LedgerReportRepository;
